import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../_services';
import { HomeService } from '../_services/home.service';

@Component({
  selector: 'app-sso-login',
  template: ``,
  styleUrls: []
})
export class SsoLoginComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService,
    private homeService: HomeService
  ) { }

  ngOnInit() {
    this.homeService.sendMessage(true);
    let url = this.router.routerState.snapshot.url;
    let shortname = url.split('/')[1];
    let source = this.route.snapshot.queryParamMap.get('source');
    let ssoError = this.route.snapshot.queryParamMap.get('error');

    /* If SSO Login Fails */
    if (source === null) {
      if (ssoError !== null && ssoError !== undefined) {
        this.authService.setValueInConfigAtLocalStorage('samlAuthFailType', ssoError);
      } else {
        this.authService.setValueInConfigAtLocalStorage('samlAuthFailType', 'userNotFound');
      }
      this.authService.removeCurrentUser();
      // localStorage.setItem('isSamlAuthFailed', 'true');
      let isCasLogin = this.authService.getConfigFromLocalStorage()['isCasLogin'];
      if (isCasLogin == 'true') {
        this.authService.setValueInConfigAtLocalStorage('isCasAuthFailed', 'true');
        this.authService.removeValueInConfigAtLocalStorage('isSamlAuthFailed');
        this.authService.removeValueInConfigAtLocalStorage('samlAuthFailType');
      } else {
        this.authService.setValueInConfigAtLocalStorage('isSamlAuthFailed', 'true');
        this.authService.removeValueInConfigAtLocalStorage('isCasAuthFailed');
      }
      // localStorage.removeItem('autoOpenChatWindow');
      // localStorage.removeItem('showCreateCaseModal');
      // localStorage.removeItem('redirectPostLoginUrl');
      this.authService.removeValueInConfigAtLocalStorage('autoOpenChatWindow');
      this.authService.removeValueInConfigAtLocalStorage('showCreateCaseModal');
      this.authService.removeValueInConfigAtLocalStorage('redirectPostLoginUrl');

      this.router.navigateByUrl(`${shortname}/home`);
    }

    const data = source;
    let isCasLogin = this.authService.getConfigFromLocalStorage()['isCasLogin'];
    if (isCasLogin == 'true') {
      this.homeService.validateCasAuth(data).subscribe((resp) => {
        this.authService.setCurrentUser(JSON.stringify(resp.return_body));
        this.authService.setValueInConfigAtLocalStorage('isCasAuthFailed', 'false');
        this.authService.removeValueInConfigAtLocalStorage('isSamlAuthFailed');
        this.authService.removeValueInConfigAtLocalStorage('samlAuthFailType');
        let redirectUrl = this.authService.getValueInConfigFromLocalStorage('redirectPostLoginUrl');
        this.authService.removeValueInConfigAtLocalStorage('redirectPostLoginUrl');
        if (redirectUrl === null) {
          this.router.navigateByUrl(`${shortname}/helpcenter`);
        } else {
          this.router.navigateByUrl(redirectUrl);
        }
        let autoOpenChat = this.authService.getValueInConfigFromLocalStorage('autoOpenChatWindow');
        if (autoOpenChat !== null && autoOpenChat === 'yes') {
          this.homeService.openChat.next(true);
        }
        let showCreateCaseModal = this.authService.getValueInConfigFromLocalStorage('showCreateCaseModal');
        let isUserLoggedIn = this.authService.isUserLoggedIn();
        if (showCreateCaseModal !== null && showCreateCaseModal === 'yes' && isUserLoggedIn) {
          this.homeService.openCreateCaseModal.next(true);
          // localStorage.removeItem('showCreateCaseModal');
          this.authService.removeValueInConfigAtLocalStorage('showCreateCaseModal');
        }

        this.homeService.sendMessage(false);
      },
        (err) => {
          this.router.navigateByUrl(`${shortname}/home`);
          this.homeService.sendMessage(false);
        })
    } else {
      this.homeService.validateSamlAuth(data).subscribe((resp) => {
        this.authService.setCurrentUser(JSON.stringify(resp.return_body));

        // localStorage.setItem('isSamlAuthFailed', 'false');
        this.authService.setValueInConfigAtLocalStorage('isSamlAuthFailed', 'false');
        this.authService.removeValueInConfigAtLocalStorage('isCasAuthFailed');
        // Post Login Redirection
        // let redirectUrl = localStorage.getItem('redirectPostLoginUrl');
        let redirectUrl = this.authService.getValueInConfigFromLocalStorage('redirectPostLoginUrl');

        // localStorage.removeItem('redirectPostLoginUrl');
        this.authService.removeValueInConfigAtLocalStorage('redirectPostLoginUrl');

        if (redirectUrl === null) {
          this.router.navigateByUrl(`${shortname}/helpcenter`);
        } else {
          this.router.navigateByUrl(redirectUrl);
        }

        /* Open Chat Interface Post Login */
        // let autoOpenChat =  localStorage.getItem('autoOpenChatWindow');
        let autoOpenChat = this.authService.getValueInConfigFromLocalStorage('autoOpenChatWindow');
        if (autoOpenChat !== null && autoOpenChat === 'yes') {
          this.homeService.openChat.next(true);
        }

        /* Open Create Case Modal Post Login */
        // let showCreateCaseModal = localStorage.getItem('showCreateCaseModal');
        let showCreateCaseModal = this.authService.getValueInConfigFromLocalStorage('showCreateCaseModal');
        let isUserLoggedIn = this.authService.isUserLoggedIn();
        if (showCreateCaseModal !== null && showCreateCaseModal === 'yes' && isUserLoggedIn) {
          this.homeService.openCreateCaseModal.next(true);
          // localStorage.removeItem('showCreateCaseModal');
          this.authService.removeValueInConfigAtLocalStorage('showCreateCaseModal');
        }

        this.homeService.sendMessage(false);
      },
        (err) => {
          this.router.navigateByUrl(`${shortname}/home`);
          this.homeService.sendMessage(false);
        });
    }
  }

}